export const SentryDns =
    'https://d3463ceebf9c4faa94ad46e12124a8b4@o1290599.ingest.sentry.io/4504518963691520'

export const OPT_ISSUER = process.env.OPT_ISSUER || 'HAL24KDimension'

export const HELP_POPOVER_DELAY = 2000
